<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{routeName}}</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>-->
          <li>
          <drop-down class="nav-item"
                     :title="$t('language')"
                     title-classes="nav-link"
                     icon="ti-lang">
            <a class="dropdown-item" href="#" @click.prevent="changeLocale('en')">English</a>
            <a class="dropdown-item" href="#" @click.prevent="changeLocale('shq')">Shqip</a>

          </drop-down>
          </li>
          <li class="nav-item">
             <a class="nav-link" href @click.prevent="logOut">
                <b>LogOut</b>
              </a>
          </li>
        </ul>
      </div>
    </div></nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      class_ln: 'dropdown-item',
      class_ln_avtive: 'dropdown-item active'
    };
  },
   mounted(){
    if(localStorage.lang!=null) this.$i18n.locale=localStorage.lang; 
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
     changeLocale(locale){
      this.$i18n.locale = locale;
      localStorage.setItem("lang",locale)
    }
  }
};
</script>
<style>
</style>
